
export class Meat
{
    SmokeID: string = "";
    MeatID: string = "";
    Description: string = "";
    Source: string = "";
    Rub: string = "";
    UntrimmedGrams: number = 0;
    TrimmedGrams: number = 0;
    InitialObs: string = "";
    Preparation: string = "";
    PostSmokeObs: string = "";
}